import { render, staticRenderFns } from "./SignupHome.vue?vue&type=template&id=ac70d6a4&"
import script from "./SignupHome.vue?vue&type=script&lang=js&"
export * from "./SignupHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports